
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class ButtonGroup extends Vue {
  @Prop({ required: true, type: Array })
  options!: { label: string; value: string }[];

  @Prop({ required: true })
  value!: string;

  @Prop({ type: String, default: "" })
  label!: string;

  update(val: string) {
    this.$emit("update", val);
  }

  isActive(val: string) {
    return this.value === val;
  }
}
